<template>
  <div class="analytics-container">
    <div class="metrics-wrapper">
      <div class="four-column-grid" >
        <div class="revenue-card">
          <CircleCardDetail @show-modal="showModal=true" :is-white="true" down-amount="-12" header="Omzet"
                            header-icon="/assets/deposit.svg"
                            :has-data="typeof financialResponse.financialData!='undefined'&& financialResponse.financialData.length>0"
                            :total-cost="(financialResponse.financialData?.[0]?.totalRevenue??0)" :change-amount="(((financialResponse.financialData?.[0]?.totalRevenue??0)-(financialResponse.financialData?.[1]?.totalRevenue??0))*100)/(financialResponse.financialData?.[1]?.totalRevenue??1)"/>
        </div>
        <div class="costs-card">
          <CircleCardDetail down-amount="12" header="Kosten" header-icon="/assets/withdraw.svg"
                            :has-data="typeof financialResponse.financialData!='undefined'&& financialResponse.financialData.length>0"
                            :total-cost="(financialResponse.financialData?.[0]?.totalExpenses??0)" :change-amount="(((financialResponse.financialData?.[1]?.totalExpenses??0)-(financialResponse.financialData?.[0]?.totalExpenses??0))*100)/(financialResponse.financialData?.[1]?.totalExpenses??1)"/>
        </div>
        <div class="profit-loss-card">
          <CircleCardDetail down-amount="12" header="Winst/Verlies" header-icon="/assets/profit_loss.svg"
                            :has-data="typeof financialResponse.financialData!='undefined'&& financialResponse.financialData.length>0"
                            :total-cost="(financialResponse.financialData?.[0]?.profitTotal??0)" :change-amount="(((financialResponse.financialData?.[0]?.profitTotal??0)-(financialResponse.financialData?.[1]?.profitTotal??0))*100)/(financialResponse.financialData?.[1]?.profitTotal??1)"/>
        </div>

        <div class="stat-row">
          <div class="stat-item">
            <div class="stat-header">
              <div class=" blue"></div>
              <span class="stat-title">Totaal aantal BV's</span>
            </div>
            <div class="stat-value">
              <span>0</span>
            </div>
          </div>
          <div class="stat-item">
            <div class="stat-header">
              <div class=" purple"></div>
              <span class="stat-title">Totaal aantal vervoersopdrachten</span>
            </div>
            <div class="stat-value">
              <span>{{ financialResponse.totalRows }}</span>
            </div>
          </div>
          <div class="stat-item">
            <div class="stat-header">
              <div class=" navy"></div>
              <span class="stat-title">Totaal aantal percelen</span>
            </div>
            <div class="stat-value">
              <div class="stat-link">
                <span>0</span>
              </div>
            </div>
          </div>
        </div>
        <DashboardPiChart :series="[(financialResponse.financialData?.[0]?.personnelCost??0),(financialResponse.financialData?.[0]?.carCost??0),(financialResponse.financialData?.[0]?.overHeadCost??0),(financialResponse.financialData?.[0]?.otherCost??0)]"
                          :labels="['Personeelskosten', 'Then Autokosten', 'Overheadskosten', 'Overige']"/>

      </div>
      <div class="metrics-grid">
        <div class="metrics-column">
          <div class="parent">
          </div>
        </div>
      </div>
    </div>
    <TimelineChart

        :series="[
    {
      name: 'Omzet',
      data: [financialResponse.financialData[0]?.totalRevenue??0, financialResponse.financialData[1]?.totalRevenue??0, financialResponse.financialData[2]?.totalRevenue??0]
    },
    {
      name: 'Kosten',
      data: [financialResponse.financialData[0]?.totalExpenses??0, financialResponse.financialData[1]?.totalExpenses??0, financialResponse.financialData[2]?.totalExpenses??0]
    },
    {
      name: 'Winst/Verlies',
      data: [financialResponse.financialData[0]?.profitTotal??0, financialResponse.financialData[1]?.profitTotal??0, financialResponse.financialData[2]?.profitTotal??0]
    }
    ]"/>
  </div>
  <UploadModal v-if="showModal" @close="showModal = false" @fileUploaded="handleFileUpload">
  </UploadModal>
</template>

<script lang="ts" setup>
import {computed, defineComponent, onMounted, PropType, ref} from 'vue'
import DashboardPiChart from './charts/DashboardPiChart.vue'
import TimelineChart from './charts/TimelineChart.vue'
import CircleCardDetail from "../components/cards/CircleCardDetail.vue";
import {dateRange, financialResponse} from "../composables/getFinancial";
import UploadModal from "../components/Modals/UploadModal.vue";


const showModal = ref(false);
const upAmount = ref();
const uploadedFile = ref<File | null>(null);
const handleUpload = () => {
  // Handle file upload logic
}
const handleFileUpload = (file: File) => {
  uploadedFile = file;
  upAmount = 14;
  // Handle the uploaded file data here
};

</script>

<style scoped>
.four-column-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr); /* Four equal columns */
  gap: 16px; /* Adjust the space between grid items */
}

.grid-item {
  background: lightgray; /* Optional: Style the grid items */
  padding: 16px;
  border-radius: 8px;
}

.parent {
  display: flex;
  flex-direction: column;
}

.flex-grow {
  flex-grow: 4;
}

.metrics-container {
  border-radius: 16px;
  border: 1px solid rgba(199, 200, 204, 0.4);
  background: var(--Neutral-background, #f7f8fc);
  padding: 20px 24px 8px;
  margin-top: 24px;
  width: 100%;
}

.metrics-grid {
  display: flex;
  gap: 20px;
}

.metrics-column {
  display: flex;
  flex-direction: column;
}

.metrics-column:first-child {
  width: 57%;
}

.metrics-column:last-child {
  width: 43%;
}

.metrics-row {
  display: flex;
  gap: 20px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
}

.metric-circle {
  border-radius: 50%;
  width: 162px;
  height: 162px;
  border: 8px solid rgba(201, 218, 253, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
}

.metric-circle.primary {
  background-color: var(--Primary-Primary, #080aed);
  color: var(--Neutral-background, #f7f8fc);
}

.metric-circle.secondary {
  background-color: var(--Primary-light-2, #83abfb);
  color: var(--Neutral-5, #191a1f);
}

.metric-circle.tertiary {
  border: 8px dashed rgba(8, 10, 237, 1);
}

.metric-content {
  border-radius: 8px;
  padding: 6px 0;
  width: 100%;
  text-align: center;
}

.metric-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 11px;
}

.metric-icon {
  width: 16px;
  height: 16px;
}

.metric-message {
  font-size: 10px;
  line-height: 14px;
  margin: 6px 0;
}

.metric-comparison {
  font-size: 7px;
  font-weight: 400;
  line-height: 13px;
  margin-top: 6px;
}

.upload-button {
  background: var(--secondary-secondary, #ff9f1c);
  border-radius: 8px;
  color: var(--Neutral-1, #fcfcfc);
  font-size: 8px;
  font-weight: 700;
  line-height: 16px;
  padding: 4px 8px;
  border: none;
  cursor: pointer;
}

.vertical-divider {
  width: 1px;
  height: 180px;
  background-color: rgba(199, 200, 204, 1);
  margin: auto 0;
}

.stats-container {
  flex-grow: 1;
  margin: auto 0;
}

.stats-grid {
  display: flex;
  gap: 20px;
}

.stats-column {
  display: flex;
  flex-direction: column;
}

.stats-column:first-child {
  width: 63%;
}

.stats-column:last-child {
  width: 37%;
}

.stat-row {
  margin-top: 20%;
  width: 290px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.stat-item {
  width: 260px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.stat-header {
  display: flex;
  align-items: center;
  gap: 8px;
}

.stat-indicator {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.stat-indicator.blue {
  background-color: var(--Color-Styles-Data-2b, #63abfd);
}

.stat-indicator.purple {
  background-color: rgba(230, 151, 255, 1);
}

.stat-indicator.navy {
  background-color: rgba(77, 59, 209, 1);
}

.stat-title {
  color: var(--Neutral-5, #191a1f);
  font: 500 12px/1 Montserrat, sans-serif;
}

.stat-value {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-left: 16px;
  font: 500 12px/1 Montserrat, sans-serif;
  color: var(--Neutral-5, #191a1f);
}

.stat-change {
  display: flex;
  align-items: center;
  gap: 7px;
}

.stat-bar {
  border-radius: 2px;
  height: 6px;
}


.stat-link {
  display: flex;
  gap: 4px;
  align-items: center;
}

.parcel-link {
  color: var(--Primary-Primary, #080aed);
  font-size: 10px;
  font-weight: 600;
  text-decoration: underline;
}

.stats-chart {
  width: 153px;
  height: 153px;
}

.timeline {
  display: flex;
  gap: 15px;
  margin: 21px 0 0 16px;
  width: 100%;
  max-width: 961px;
}

.timeline-labels {
  display: flex;
  flex-direction: column;
  gap: 20px;
  color: var(--Neutral-5, #191a1f);
  font: 500 12px/1 Montserrat, sans-serif;
}

.timeline-bars {
  border: 1px solid var(--Gray-1, #f1f1f1);
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-right: 80px;
}

.timeline-bar {
  border: 1px solid var(--Gray-1, #f1f1f1);
  height: 11px;
}

.timeline-bar.pink {
  background: var(--Data-1b, #ffa5cb);
  width: 429px;
}

.timeline-bar.blue {
  background: var(--Data-2b, #63abfd);
  width: 351px;
}

.legend {
  display: flex;
  align-items: start;
  gap: 20px;
  justify-content: space-between;
  margin-top: 4px;
  width: 100%;
  max-width: 977px;
}

.legend-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.legend-value {
  color: var(--Neutral-5, #191a1f);
  font: 400 10px/18px Montserrat, sans-serif;
  text-align: center;
}

.legend-items {
  display: flex;
  align-items: center;
  gap: 8px;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.legend-indicator {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.legend-indicator.blue {
  background-color: var(--Color-Styles-Data-2b, #63abfd);
}

.legend-indicator.purple {
  background-color: var(--Color-Styles-Data-3b, #e697ff);
}

.legend-indicator.pink {
  background-color: var(--Color-Styles-Data-1b, #ffa5cb);
}

@media (max-width: 991px) {
  .metrics-container {
    padding-left: 20px;
  }

  .metrics-grid {
    flex-direction: column;
  }

  .metrics-column:first-child,
  .metrics-column:last-child {
    width: 100%;
  }

  .metrics-column:first-child {
    margin-top: 40px;
  }

  .stats-container {
    margin-top: 40px;
  }

  .stats-grid {
    flex-direction: column;
  }

  .stats-column:first-child,
  .stats-column:last-child {
    width: 100%;
  }

  .stats-chart {
    margin-top: 16px;
  }

  .timeline,
  .legend {
    max-width: 100%;
  }
}

.parent {
  display: flex; /* Use flexbox for row layout */
  justify-content: space-between; /* Space between circles */
  width: 100%; /* Full width parent */
}

.circle {
  width: 33%; /* Each circle takes 33% of the parent width */
  aspect-ratio: 1 / 1; /* Maintain a 1:1 aspect ratio */
  background-color: #2590F4; /* Blue background color */
  border-radius: 50%; /* Make it a circle */
}

.profit-loss-card {
  margin-right: 8px;
  aspect-ratio: 1 / 1; /* Maintain a 1:1 aspect ratio */
  border-radius: 50%; /* Make it a circle */
  stroke-width: 6px;
  stroke: var(--blue-3, #2590f4);
  padding: 8px 8px;
  border: 6px dashed rgba(8, 10, 237, 1);
  display: flex; /* Use flexbox */
  align-items: center; /* Center items vertically */
  justify-content: center; /* Center items horizontally */
}

.revenue-card {
  margin-right: 8px;
  aspect-ratio: 1 / 1; /* Maintain a 1:1 aspect ratio */
  background-color: rgba(8, 10, 237, 1); /* Blue background */
  border-radius: 50%; /* Make it a circle */
  padding: 8px 8px;
  border: 12px solid rgba(201, 218, 253, 1); /* Border styling */
  display: flex; /* Use flexbox */
  align-items: center; /* Center items vertically */
  justify-content: center; /* Center items horizontally */
}

.costs-card {
  margin-right: 8px;
  aspect-ratio: 1 / 1; /* Maintain a 1:1 aspect ratio */
  border-radius: 50%; /* Make it a circle */
  stroke-width: 12px;
  padding: 8px 8px;
  background-color: rgba(131, 171, 251, 1);
  fill: rgba(131, 171, 251, 1);
  stroke: var(--blue-1, #e2f0fd);
  border: 12px solid rgba(226, 240, 253, 1);
  display: flex; /* Use flexbox */
  align-items: center; /* Center items vertically */
  justify-content: center; /* Center items horizontally */
}

@media (max-width: 1400px) {
  .parent {
    justify-content: space-between; /* Space between circles */
    width: 100%; /* Full width parent */
    flex-direction: column; /* Change to column layout on mobile */
  }

  .stats-grid {
    flex-direction: column;
  }

  .stats-container {
    margin-top: 40px;
  }

  .profit-loss-card {
    margin-bottom: 16px;
    margin-right: 8px;
    aspect-ratio: 1 / 1; /* Maintain a 1:1 aspect ratio */
    border-radius: 50%; /* Make it a circle */
    stroke-width: 12px;
    stroke: var(--blue-3, #2590f4);
    padding: 8px 8px;
    border: 12px dashed rgba(37, 144, 244, 1);
    display: flex; /* Use flexbox */
    align-items: center; /* Center items vertically */
    justify-content: center; /* Center items horizontally */
  }

  .revenue-card {
    margin-bottom: 16px;
    margin-right: 8px;
    aspect-ratio: 1 / 1; /* Maintain a 1:1 aspect ratio */
    background-color: rgba(8, 10, 237, 1); /* Blue background */
    border-radius: 50%; /* Make it a circle */
    padding: 8px 8px;
    border: 12px solid rgba(226, 240, 253, 1); /* Border styling */
    display: flex; /* Use flexbox */
    align-items: center; /* Center items vertically */
    justify-content: center; /* Center items horizontally */
  }

  .costs-card {
    margin-bottom: 16px;
    margin-right: 8px;
    aspect-ratio: 1 / 1; /* Maintain a 1:1 aspect ratio */
    border-radius: 50%; /* Make it a circle */
    stroke-width: 12px;
    padding: 8px 8px;
    background-color: var(--blue-2, #86c1f9);
    fill: var(--blue-2, #86c1f9);
    stroke: var(--blue-1, #e2f0fd);
    border: 12px solid rgba(226, 240, 253, 1);
    display: flex; /* Use flexbox */
    align-items: center; /* Center items vertically */
    justify-content: center; /* Center items horizontally */
  }

  .circle {
    width: 100%; /* Each circle takes 33% of the parent width */
    aspect-ratio: 1 / 1; /* Maintain a 1:1 aspect ratio */
    background-color: #2590F4; /* Blue background color */
    border-radius: 50%; /* Make it a circle */
  }
}

.analytics-container {
  border-radius: 16px;
  border: 1px solid rgba(199, 200, 204, 0.4);
  background: var(--Neutral-background, #f7f8fc);
  display: flex;
  margin-top: 8px;
  width: 100%;
  flex-direction: column;
  overflow: hidden;
  align-items: start;
  padding: 16px 16px 8px;
}

.metrics-wrapper {
  height: 30%;
  width: 100%;
}

.metrics-grid {
  gap: 8px;
  display: flex;
}

.metrics-column {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-right: 24px;
  margin-left: 24px;
  line-height: normal;
  justify-content: space-around;
  height: 100%; /* Ensure the column fills the parent container */
}

.business-column {
  display: flex;
  flex-direction: column;
  line-height: normal;
  width: 32%;
}

@media (max-width: 991px) {
  .analytics-container {
    max-width: 100%;
    padding-left: 20px;
  }

  .metrics-wrapper {
    max-width: 100%;
  }

  .metrics-grid {
    flex-direction: column;
    align-items: stretch;
    gap: 0;
  }

  .metrics-column {
    width: 100%;
  }

  .business-column {
    width: 100%;
  }
}
</style>